export default "__VITE_ASSET__D2oQ$O8X__"